<template>
    <div class="h-90">
        <div class="chat-messages h-100">
            <template v-for="(message, idx) in messages">
                <Message :key="idx" :message="message" />
            </template>
        </div>
        <div class="m-2">
            <div class="field has-addons">
                <div class="control is-expanded">
                    <input
                        type="text"
                        class="input is-normal is-radiusless"
                        v-model="message"
                        @keypress.enter.prevent="sendMessage"
                    />
                </div>
                <div class="control">
                    <button
                        class="button is-primary is-outlined is-radiusless"
                        @click="sendMessage"
                        :disabled="message === ''"
                    >
                        <Icon family="fal" name="fa-paper-plane" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/components/chat/Message.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "chat",
    components: { Message },
    props: {
        roomId: {
            type: String,
            required: true,
        },
        signalRSocket: Object,
    },
    data() {
        return {
            message: "",
            messages: [],
        };
    },
    mounted() {
        this.messages = this.getMessages;

        this.signalRSocket.on("ChatMessage", this.signalRChatMessage);
    },
    watch: {
        getMessages(newMessages) {
            let messages = [...newMessages];
            this.messages = messages.reverse();
        },
    },
    computed: {
        ...mapGetters("chat", ["getMessages"]),
        ...mapGetters("conference", ["getParticipantId"]),
    },
    methods: {
        ...mapActions("chat", ["toggleChat", "addMessage"]),
        sendMessage() {
            if (this.message === "") return;
            // this.$emit("sendMessage", this.message);
            this.sendMessageSignalR(this.message);
            this.message = "";
        },
        sendMessageSignalR(text) {
            this.addMessage({ text });
            this.signalRSocket.invoke(
                "ChatMessage",
                this.roomId,
                this.getParticipantId,
                text
            );
        },
        closeChat() {
            this.toggleChat();
        },
        signalRChatMessage(response) {
            this.addMessage(response);
        },
    },
};
</script>

<style lang="scss">
.chat-messages {
    max-height: 72vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column-reverse;
}

.bottom-separator {
    border-bottom: lightgrey 1px solid;
}
</style>